import React, { useRef } from "react";
import emailjs from "emailjs-com";
import { Button } from "../";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FormFive = () => {
  const formRef = useRef();

  const formHandle = (event) => {
    event.preventDefault();

    emailjs
      .sendForm(
        "service_nuk7zco", // Replace with your EmailJS Service ID
        "template_yf4dhbn", // Replace with your Template ID
        formRef.current,
        "-aE0E4bvffLzX8WE_" // Replace with your Public Key
      )
      .then(
        () => {
          toast.success("✅ Message sent successfully!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          formRef.current.reset();
        },
        (error) => {
          console.error(error);
          toast.error("❌ Failed to send message. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      );
  };
  return (
    <>
      <form ref={formRef} onSubmit={formHandle} className="vs-contact-form">
        <div className="row gx-20">
          <div className="col-md-6 form-group">
            <input
              type="text"
              name="user_name"
              placeholder="Your Name"
              required
            />
            <i className="fal fa-user" />
          </div>

          <div className="col-md-6 form-group">
            <input
              type="email"
              name="user_email"
              placeholder="Email Address"
              required
            />
            <i className="fal fa-envelope" />
          </div>

          <div className="col-12 form-group">
            <select name="subject" required>
              <option value="">Select a Service</option>
              <option value="Custom Software Development">
                Custom Software Development
              </option>
              <option value="Web Development">Web Development</option>
              <option value="Mobile App Development">
                Mobile App Development
              </option>
              <option value="ERP & CRM Solutions">ERP & CRM Solutions</option>
              <option value="Managed IT Services">Managed IT Services</option>
              <option value="Cloud & Infrastructure Support">
                Cloud & Infrastructure Support
              </option>
              <option value="IT Consulting">IT Consulting</option>
              <option value="SAP Support & Implementation">
                SAP Support & Implementation
              </option>
            </select>
          </div>

          <div className="col-12 form-group">
            <textarea name="message" placeholder="Type Your Message" required />
          </div>

          <div className="col-12">
            <Button type="submit">
              Submit Message
              <i className="far fa-arrow-right" />
            </Button>
          </div>
        </div>
      </form>
      {/* Toast container for notifications */}
      <ToastContainer />
    </>
  );
};

export default FormFive;
